import { render, staticRenderFns } from "./TokenPinStep.vue?vue&type=template&id=145cd2ee&scoped=true&"
import script from "./TokenPinStep.vue?vue&type=script&lang=ts&"
export * from "./TokenPinStep.vue?vue&type=script&lang=ts&"
import style0 from "./TokenPinStep.vue?vue&type=style&index=0&id=145cd2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cd2ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSpacer,VTextField})
